import moment from "moment";
import { useCallback, useMemo, useState } from "react";
import useRouter from "use-react-router";

import { LogFilterRequest } from "../rest/requestObjects/eventLogRequest";

export function useLogFilterRequest(partial?: Partial<LogFilterRequestFormObj>): {
    request: LogFilterRequest,
    formObj: LogFilterRequestFormObj,
    setFormObj: React.Dispatch<React.SetStateAction<LogFilterRequestFormObj>>;
    resetFormObj: () => void;
} {
    const { history } = useRouter();
    const routeState = history.location.state;

    const initialFilter = { ...routeState, eventTypes: routeState?.eventTypes || partial?.eventTypes };
    const [formObj, setFormObj] = useState<LogFilterRequestFormObj>(
        createInitialLogFilterRequestFormObj(initialFilter)
    );

    const resetFormObj = useCallback(() => {
        setFormObj(createInitialLogFilterRequestFormObj(partial));
    }, [partial]);

    const request = useMemo(() => {
        return makeLogFilterRequestFromFormObj(formObj);
    }, [formObj]);

    return {
        request,
        formObj,
        setFormObj,
        resetFormObj,
    };
}


// TODO: Remove formObj related after adjusting all
// components that are modifying values used in this request obj

export interface LogFilterRequestFormObj {
    from: string | null;
    to: string | null;
    eventTypes: EventTypeFilterFormObj[] | undefined;
    searchText: string;
    page: number;
    itemsPerPage: number;
    employeeToSearch: string | undefined;
    customerToSearch: string | undefined;
    filterByLocalTime: boolean;
    wasInMaintenanceMode?: boolean | null;
}

export interface EventTypeFilterFormObj {
    eventType: number;
    eventNames: number[];
}

export function createInitialLogFilterRequestFormObj(partial?: Partial<LogFilterRequestFormObj>): LogFilterRequestFormObj {
    return {
        ...{
            from: moment().subtract(30, "days").toISOString(),
            to: moment().add(1, "day").toISOString(),
            eventTypes: undefined,
            searchText: "",
            page: 0,
            itemsPerPage: 500,
            employeeToSearch: undefined,
            customerToSearch: undefined,
            filterByLocalTime: true,
            wasInMaintenanceMode: null,
        },
        ...(partial ? partial : {}),
    };
}

export function makeLogFilterRequestFromFormObj(obj: LogFilterRequestFormObj): LogFilterRequest {
    return {
        from: obj.from,
        to: obj.to,
        eventTypes: obj.eventTypes || [],
        searchText: obj.searchText,
        page: obj.page + 1,
        itemsPerPage: obj.itemsPerPage,
        employeeToSearch: obj.employeeToSearch || null,
        customerToSearch: obj.customerToSearch || null,
        filterByLocalTime: obj.filterByLocalTime,
        wasInMaintenanceMode: obj.wasInMaintenanceMode,
    };
}